import { isDateWithin24Hours } from './helpers';

const months: any = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sept',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export function notificationTime(createdAt: Date) {
  const nowTime = new Date().getTime();
  const createdTime = new Date(createdAt).getTime();
  const oneHourInMilliseconds = 1000 * 60 * 60;
  if (nowTime - createdTime < oneHourInMilliseconds) {
    return `${Math.floor((nowTime - createdTime) / (1000 * 60))} minutes ago`;
  }
  const oneDayInMilliseconds = oneHourInMilliseconds * 24;
  if (nowTime - createdTime < oneDayInMilliseconds) {
    return `${Math.floor((nowTime - createdTime) / (1000 * 60 * 60))} hours ago`;
  }
  return `${Math.ceil((nowTime - createdTime) / (1000 * 60 * 60 * 24))} days ago, ${createdAt
    .toDateString()
    .slice(0, -5)}`;
}

export const adjustDateForTimezone = (date: Date) => {
  const tempDate = new Date(date);
  tempDate.setMinutes(tempDate.getMinutes() + tempDate.getTimezoneOffset());
  return tempDate;
};

export function daysTillDueDate(dueDate?: Date) {
  if (!dueDate) return;
  const tempDate = adjustDateForTimezone(dueDate);

  const now = new Date();
  const diffTime = tempDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function workOrderDueDate(dueDate?: Date) {
  if (!dueDate) return;
  const tempDate = adjustDateForTimezone(dueDate);

  const comparisonDate = new Date(tempDate);
  // plus 1 to ensure if dueDate == today, it will not render past due
  comparisonDate.setDate(comparisonDate.getDate() + 1);

  if (dueDate && comparisonDate < new Date()) return 'Past due';
  const days = daysTillDueDate(dueDate);

  if (days === 0) return 'Due today';
  return days === 1 ? `Due in ${days} day` : `Due in ${days} days`;
}

export const mmddyyyyDate = (date: Date) => {
  const tempDate = adjustDateForTimezone(date);

  const month = tempDate.getMonth() + 1;
  const day = tempDate.getDate();
  const year = tempDate.getFullYear();
  return `${month}/${day}/${year}`;
};

export const renderTimeStatusOnWorkOrder = (
  isCompleted: boolean,
  completedAt: Date,
  createdAt: Date,
  dueDate: Date,
  showDate?: boolean,
) => {
  if (isCompleted) {
    if (completedAt) {
      return `Completed on ${mmddyyyyDate(completedAt)}`;
    } else {
      return 'Completed';
    }
  } else {
    if (showDate && dueDate) {
      return `Due on ${mmddyyyyDate(dueDate)}`;
    }
    if (isDateWithin24Hours(createdAt)) {
      return 'New';
    } else if (dueDate) {
      return workOrderDueDate(dueDate);
    } else {
      return 'No due date';
    }
  }
};

export function createdAtTime(createdAt: Date) {
  const nowTime = new Date().getTime();
  const createdTime = new Date(createdAt).getTime();
  const oneHourInMilliseconds = 1000 * 60 * 60;
  const oneDayInMilliseconds = oneHourInMilliseconds * 24;
  if (nowTime - createdTime < oneHourInMilliseconds) {
    return `${Math.floor((nowTime - createdTime) / (1000 * 60))} minutes ago`;
  }
  if (nowTime - createdTime < oneDayInMilliseconds) {
    const hours = Math.floor((nowTime - createdTime) / (1000 * 60 * 60));
    if (hours < 1) {
      return `${Math.floor((nowTime - createdTime) / (1000 * 60))} minutes ago`;
    } else if (hours < 2) {
      return `${hours} hour ago`;
    } else {
      return `${hours} hours ago`;
    }
  }
  return `on ${createdAt.toLocaleDateString('en-US')}`;
}

export const formatDollarAmountWithoutDecimal = (amount?: number) => {
  return amount
    ? amount.toLocaleString('en-EN', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      })
    : '$0';
};

export function formatPhoneNumber(phone: string) {
  if (!phone) return null;
  phone = phone.replace(/[^0-9]/g, '');
  // Takes a phone number with atleast 11 digits (including country code) and formats it to +x (xxx) xxx-xxxx
  if (phone.length >= 11) {
    return `+${phone.substring(0, phone.length - 10)} (${phone.substring(
      phone.length - 10,
      phone.length - 7,
    )}) ${phone.substring(phone.length - 7, phone.length - 4)}-${phone.substring(
      phone.length - 4,
    )}`;
    // takes a phone number with 10 digits and formats it to (xxx) xxx-xxxx
  } else if (phone.length === 10) {
    return `(${phone.substring(phone.length - 10, phone.length - 7)}) ${phone.substring(
      phone.length - 7,
      phone.length - 4,
    )}-${phone.substring(phone.length - 4)}`;
  } else {
    return phone;
  }
}

export function expiresInDays(expiresAt: Date) {
  const expiresInDays = Math.ceil(
    (new Date(expiresAt).getTime() - new Date().getTime()) / (1000 * 3600 * 24),
  );
  return expiresInDays;
}
